import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API_BASE_URL } from "../config/apiBase";

const AdminUploadCourse = () => {
  const [title, setTitle] = useState("");
  const [level, setLevel] = useState("Intermediate");
  const [duration, setDuration] = useState("");
  const [classes, setClasses] = useState("");
  const [description, setDescription] = useState("");
  const [video, setVideo] = useState(null);
  const [requiredPlan, setRequiredPlan] = useState("free");
  const [status, setStatus] = useState("in_progress");
  const [isAuthorized, setIsAuthorized] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user && user.id === 1) {
      setIsAuthorized(true);
    } else {
      alert("Access Denied: Only Admin can upload courses.");
      navigate("/dashboard");
    }
  }, [navigate]);

  const handleUpload = async (e) => {
    e.preventDefault();

    if (!video) return alert("Please select a course video/image file");

    const formData = new FormData();
    formData.append("title", title);
    formData.append("level", level);
    formData.append("duration", duration);
    formData.append("classes", classes);
    formData.append("description", description);
    formData.append("video", video);
    formData.append("required_plan", requiredPlan);
    formData.append("status", status);

    try {
      const token = localStorage.getItem("token");

      await axios.post(`${API_BASE_URL}/courses/upload`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      alert("Course uploaded successfully!");
      setTitle("");
      setLevel("1");
      setDuration("");
      setClasses("");
      setDescription("");
      setVideo(null);
      setRequiredPlan("free");
      setStatus("in_progress");
    } catch (error) {
      console.error("Upload failed:", error);
      alert("Course upload failed.");
    }
  };

  if (!isAuthorized) return <p className="text-center text-red-500 mt-10">Unauthorized</p>;

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center py-10 px-4">
      <div className="bg-white shadow-md rounded-lg p-8 w-full max-w-2xl">
        <h2 className="text-2xl font-bold mb-6 text-center text-gray-800">Upload a New Course</h2>
        <form onSubmit={handleUpload} className="space-y-4">
          <div className="space-y-2">
            <label className="block font-medium text-gray-700">Course Title</label>
            <input
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              required
              className="w-full border border-gray-300 p-3 rounded-md"
            />
          </div>

          <div className="space-y-2">
            <label className="block font-medium text-gray-700">Course Level</label>
            <input
              type="text"
              value={level}
              onChange={(e) => setLevel(e.target.value)}
              required
              className="w-full border border-gray-300 p-3 rounded-md"
            />
          </div>

          <div className="space-y-2">
            <label className="block font-medium text-gray-700">Duration</label>
            <input
              type="text"
              value={duration}
              onChange={(e) => setDuration(e.target.value)}
              required
              className="w-full border border-gray-300 p-3 rounded-md"
            />
          </div>

          <div className="space-y-2">
            <label className="block font-medium text-gray-700">Number of Classes</label>
            <input
              type="text"
              value={classes}
              onChange={(e) => setClasses(e.target.value)}
              required
              className="w-full border border-gray-300 p-3 rounded-md"
            />
          </div>

          <div className="space-y-2">
            <label className="block font-medium text-gray-700">Description</label>
            <textarea
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              required
              className="w-full border border-gray-300 p-3 rounded-md"
            ></textarea>
          </div>

          <div className="space-y-2">
            <label className="block font-medium text-gray-700">Required Plan</label>
            <select
              value={requiredPlan}
              onChange={(e) => setRequiredPlan(e.target.value)}
              className="w-full border border-gray-300 p-3 rounded-md"
            >
              <option value="Beginner">Beginner</option>
              <option value="Intermediate">Intermediate</option>
              <option value="Advanced">Advanced</option>
            </select>
          </div>

          <div className="space-y-2">
            <label className="block font-medium text-gray-700">Status</label>
            <select
              value={status}
              onChange={(e) => setStatus(e.target.value)}
              className="w-full border border-gray-300 p-3 rounded-md"
            >
              <option value="in_progress">In Progress</option>
              <option value="completed">Completed</option>
            </select>
          </div>

          <div className="space-y-2">
            <label className="block font-medium text-gray-700">Course Video/Image</label>
            <input
              type="file"
              accept="video/mp4,image/*"
              onChange={(e) => setVideo(e.target.files[0])}
              className="w-full border border-gray-300 p-3 rounded-md"
              required
            />
          </div>

          <button
            type="submit"
            className="w-full bg-blue-600 text-white font-semibold py-3 rounded-md hover:bg-blue-700 transition duration-200"
          >
            Upload Course
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminUploadCourse;
